module.exports = __webpack_public_path__ + "img/tokens.66d5ecaa.svg";